// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import PricingToggleController from "./pricing_toggle_controller"
application.register("pricing-toggle", PricingToggleController)

import SheetMarkupController from "./sheet_markup_controller"
application.register("sheet-markup", SheetMarkupController)

import AutoDismissController from "./auto_dismiss_controller"
application.register("auto-dismiss", AutoDismissController)

import ElapsedController from "./elapsed_controller"
application.register("elapsed", ElapsedController)
